// extracted by mini-css-extract-plugin
export var container = "LargeCards-module--container--1nvne";
export var grid = "LargeCards-module--grid--3trzO";
export var shortText = "LargeCards-module--short-text--eEnCy";
export var postCard = "LargeCards-module--post-card--3jkuA";
export var pad = "LargeCards-module--pad--27hLl";
export var postCardLink = "LargeCards-module--post-card-link--19tEj";
export var postLink = "LargeCards-module--post-link--2r4DM";
export var cardImage = "LargeCards-module--card-image--3HygD";
export var fullImage = "LargeCards-module--full-image--2_sPP";
export var cardType = "LargeCards-module--card-type--5fn4y";
export var Grey = "LargeCards-module--Grey--wSorU";